import gql from 'graphql-tag';
import { debounce } from 'lodash';

import { DEBOUNCED_CALL_STATUS } from 'src/const';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const TIMEOUT_EDITOR_UPDATE = 500;

const MUTATION = gql`
  mutation SaveProjectEditorContent($projectId: ID!, $html: String!) {
    saveProjectEditorContent(projectId: $projectId, html: $html) {
      id
      editorContent
    }
  }
`;

export const saveProjectEditorContentDebounced = debounce((projectId, html, callback) => {
  callback(DEBOUNCED_CALL_STATUS.started);

  const variables = { projectId, html };
  return executeGqlMutation({
    mutation: MUTATION,
    variables,
  })
    .then(({ data }) => getSingleProp(data))

    .catch((error) => {
      callback(DEBOUNCED_CALL_STATUS.error, error);
    });
}, TIMEOUT_EDITOR_UPDATE);
